var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17241_21267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.668 13.5H19.3346",
    stroke: "#1650FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.668 16.8333H17.668",
    stroke: "#1650FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9.33325C21.663 9.33325 22.2989 9.59664 22.7678 10.0655C23.2366 10.5343 23.5 11.1702 23.5 11.8333V18.4999C23.5 19.163 23.2366 19.7988 22.7678 20.2677C22.2989 20.7365 21.663 20.9999 21 20.9999H16.8333L12.6667 23.4999V20.9999H11C10.337 20.9999 9.70107 20.7365 9.23223 20.2677C8.76339 19.7988 8.5 19.163 8.5 18.4999V11.8333C8.5 11.1702 8.76339 10.5343 9.23223 10.0655C9.70107 9.59664 10.337 9.33325 11 9.33325H21Z",
    stroke: "#1650FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17241_21267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.29bea8f635908a30e92cc31b77570db2.svg";
export { ForwardRef as ReactComponent };